import styled from '@emotion/styled';
import { Button } from '@presentation/components';
import { responsiveFontSize } from '@presentation/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export const ItemWrapper = styled(Link)`
  padding: 25px;
  width: 220px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ItemImage = styled.img`
  height: 138px;
  width: auto;
  object-fit: contain;
`;

export const ItemTitle = styled.div`
  ${responsiveFontSize(25, 2)};
  font-weight: 700;
  margin-top: 30px;
  color: ${(props) => props.theme.color.blue.default};
  text-align: center;
  white-space: nowrap;
`;

export const ItemButton = styled(Button)`
  margin: 40px auto auto;
  max-width: 100%;
  text-transform: uppercase;
`;
